import { render, staticRenderFns } from "./detailContract.vue?vue&type=template&id=d4d9c8e4&scoped=true&"
import script from "./detailContract.vue?vue&type=script&lang=js&"
export * from "./detailContract.vue?vue&type=script&lang=js&"
import style0 from "./detailContract.vue?vue&type=style&index=0&id=d4d9c8e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d9c8e4",
  null
  
)

export default component.exports